import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getSettings(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data); 
    return apiAction({
        types: ["GET_SETTINGS_REQUESTED", "GET_SETTINGS_SUCCESS", "GET_SETTINGS_FAILED"],
        method: "POST",
        path: "admin/get_settings",
        body: data
    });
}

export function updateSettings(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    appendTokenName(data); 
    return apiAction({
        types: ["UPDATE_SETTINGS_REQUESTED", "UPDATE_SETTINGS_SUCCESS", "UPDATE_SETTINGS_FAILED"],
        method: "POST",
        path: "admin/update_setting",
        body: data
    });
}








// WEBPACK FOOTER //
// ./src/actions/actionSettings.js